import { useContext } from 'react'
import RoutingContext from '../routing-context'

export const useRoutingContext = () => {
  const context = useContext(RoutingContext)
  
  if (context === undefined) {
    throw new Error('useRoutingContext must be used within a RoutingProvider')
  }
  
  return context
}
